export const MIN_DISPLAY_BRIGHTNESS = 0;
export const MAX_DISPLAY_BRIGHTNESS = 1;
